export default "__VITE_ASSET__CurvNXu3__"